export default "__VITE_ASSET__BQ$$hRHh__"